import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const emptyTodayWrapperIsPhoneCss = "e1tb7ki5";
const emptyTodayWrapperCss = "e1v1vuji";
export const EmptyTodayWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(emptyTodayWrapperCss, {
    [emptyTodayWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const noUpcomingMeetingWrapperCss = "n15m8t03";
export const NoUpcomingMeetingWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    paddingHeight,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = paddingHeight ? {
    paddingBottom: paddingHeight
  } : undefined;
  return <Component ref={ref} {...restProps} style={style} className={classNames(noUpcomingMeetingWrapperCss, props.className)} />;
});
const eventsGroupPhoneCss = "e1qkfr8u";
const eventsGroupCss = "ecvnw3r";
export const EventsGroup = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(eventsGroupCss, {
    [eventsGroupPhoneCss]: isPhone
  }, props.className)} />;
});
const dateBadgeContainerIsPhoneCss = "d1v2cmlb";
const dateBadgeContainerIsSameYearCss = "d1j24zfb";
const dateBadgeContainerCss = "d1nvuj4";
export const DateBadgeContainer = forwardRef((props, ref) => {
  const {
    isFirst,
    isSameYear,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(dateBadgeContainerCss, {
    [dateBadgeContainerIsPhoneCss]: isPhone,
    [dateBadgeContainerIsSameYearCss]: isSameYear
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");